//import { HashLink } from "react-router-hash-link";
import Hero from "../components/homepage/Hero";
import PillarCard from "../components/homepage/PillarCard";
import ProgramCard from "../components/homepage/ProgramCard";
import JourneyTeaser from "../components/homepage/JourneyTeaser";
import RecentPosts from "../components/blogs/RecentPosts";
import Footer from "../components/homepage/Footer";

export default function Home() {
  return (
    <div className="w-full flex flex-col gap-12">
      {/* Hero + Pillars Section with Recent Posts Sidebar */}
      <div className="flex flex-col lg:flex-row gap-8 px-4 md:px-10 py-16">
        {/* Left Column: Hero + Pillars */}
        <div className="flex-1 flex flex-col gap-2">
          {/* Hero Section */}
          <Hero
            title="Train Like a High Performer"
            subtitle="I train athletes, professionals, and high performers to unlock their full potential."
            cta="Start Your Training"
          />

          {/* Our 4 Pillars Section */}
          <section className="py-16 bg-black/30 rounded-2xl px-6">
            <div className="max-w-[95%] mx-auto">
              {/* Big container box */}
              <div className="flex flex-col gap-8 items-center max-w-[1200px] w-full bg-white/5 backdrop-blur-md border-2 border-gray-600 rounded-2xl p-6 md:p-12 mx-auto">
                {/* Heading & Description */}
                <div className="text-center">
                  <h2 className="text-white text-3xl md:text-4xl font-bold mb-6">
                    Four Pillars of Peak Performance
                  </h2>
                  <p className="text-grayText text-lg md:text-xl">
                    Each pillar represents a cornerstone of complete athletic
                    development. Together, they create a holistic system that
                    transforms your body, sharpens your mind, and elevates your
                    performance in every arena of life.
                  </p>
                </div>

                {/* Pillar Cards Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 w-full">
                  <PillarCard
                    title="Endurance"
                    description="Build cardiovascular strength and mental toughness through progressive training."
                    link="/kalon-method#endurance"
                  />
                  <PillarCard
                    title="Strength & Aesthetics"
                    description="Develop lean, symmetrical muscle for power and presence."
                    link="/kalon-method#strength"
                  />
                  <PillarCard
                    title="Sports Performance"
                    description="Train with precision for the specific demands of your sport."
                    link="/kalon-method#sports"
                  />
                  <PillarCard
                    title="Nutrition & Longevity"
                    description="Fuel your body for sustained excellence and long-term health."
                    link="/kalon-method#nutrition"
                  />
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* Right Sidebar: Recent Posts */}
        <div className="hidden lg:block lg:w-1/4 sticky top-20 self-start">
          <RecentPosts />
        </div>
      </div>

      {/* Programs Teaser Section */}
      <section className="max-w-[95%] mx-auto py-12 bg-black/30 rounded-2xl px-4 md:px-6">
        <div className="max-w-[95%] mx-auto">
          {/* Big container box */}
          <div className="flex flex-col gap-6 items-center max-w-[1200px] w-full bg-white/5 backdrop-blur-md border-2 border-gray-600  rounded-2xl p-6 md:p-12 mx-auto">
            {/* Heading & Description */}
            <div className="text-center mb-6">
              <h2 className="text-white text-3xl md:text-4xl font-bold mb-4">
                Programs Designed For You
              </h2>
              <p className="text-grayText text-lg md:text-xl">
                Explore targeted programs built for endurance, strength, sports
                performance, and complete coaching.
              </p>
            </div>

            {/* Programs Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full">
              <ProgramCard
                title="Endurance Programs"
                description="6-12 week training plans to build stamina and resilience."
                link="/programs#endurance_program"
                className="hover:scale-105 transition-transform duration-300 shadow-lg rounded-xl p-6 bg-black/40 backdrop-blur-sm"
              />
              <ProgramCard
                title="Strength & Aesthetic Programs"
                description="Transform your body with structured strength and physique plans."
                link="/programs#strength_program"
                className="hover:scale-105 transition-transform duration-300 shadow-lg rounded-xl p-6 bg-black/40 backdrop-blur-sm"
              />
              <ProgramCard
                title="Sport-Specific Programs"
                description="Train with precision for the demands of your sport."
                link="/programs#sports_program"
                className="hover:scale-105 transition-transform duration-300 shadow-lg rounded-xl p-6 bg-black/40 backdrop-blur-sm"
              />
            </div>
          </div>
        </div>
      </section>

{/* My Journey Teaser Section */}
<section className="max-w-[95%] mx-auto py-12 bg-black/30 rounded-2xl px-4 md:px-6">
  <div className="max-w-[95%] mx-auto">
    {/* Big container box */}
    <div className="flex flex-col lg:flex-row gap-8 items-center max-w-[1200px] w-full bg-white/5 backdrop-blur-md border-2 border-gray-600 rounded-2xl p-6 md:p-12 mx-auto">
      
      {/* Journey Teaser */}
      <JourneyTeaser
        title="My Journey"
        text="From running marathons to conquering 14ers, discover the path that inspired the creation of Kalon Fitness and my approach to high performance training."
        cta="Read More"
        link="/my-journey"
      />
    </div>
  </div>
</section>


      {/* Footer */}
      <Footer />
    </div>
  );
}
